var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thumbnail)?_c('div',{staticClass:"carousel-slide fc-flex-col-center"},[_c(_vm.thumbnail.component,_vm._b({tag:"component"},'component',_vm.thumbnail,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }